import {
    RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_SUCCESS,
    RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_ERROR,
    RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_START,
} from "Constant";
const initialState = {
    loading: false,
    data: []

};

export default function UpdateApprovalDetailsReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_START:
            return {
                ...state,
                loading: true,
            };
        case RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case RENTAL_ADMIN_UPDATE_APPROVAL_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}
